import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_PRODUCTS_SUCCESS:
      return Object.assign({},
        state, {
          products: action.products,
        });
    case constants.GET_PRODUCT_BY_ID_SUCCESS:
      return Object.assign({},
        state, {
          product: action.product,
        });
    case constants.GET_PRODUCTS_ERROR:
    case constants.GET_PRODUCT_BY_ID_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
};
